// 0. src/utils/prontest.js
// 1. import { useEvaluator } from '@/utils/prontest'
// 2. const ev = useEvaluator()
// 3. onMounted = { ev.opts = comp.opts }
const Prontest = class {
    _opts = {
        base : { 
            best:10, good:20, average:30, fair:40, poor:'etc', 
            pitch_weight:30, 
            pitch_guide:{ 
                best:0, good:50, average:70, fair:90, poor:'etc'
            } 
        }
    }

    get opts() {
        return this._opts
    }
    set opts(args) {
        // set
        if( arguments.length > 0 ){
            let o = arguments[0]
            if( Object.keys(o).indexOf('base') >= 0 ){
                this._opts.base = o.base
            }
        }
    }

    constructor() {
    }

    // Native speaker sample calculation
    getRules = (natives) => {
        let ctrls = []             // native result list
        let idxl = []              // native index list
        let lens = []              // native token speech length
        let pers = []              // native token accuracy
        let avgs = []              // native token speech length average
        let pitch = { list:[], dlst:[], min:1000, max:-1000, dist:1000, idx:0 }
        let pmin = { idx:0, dist:1000 }, pmax = { idx:0, dist:0 }

        for(let i=0; i<natives.length; i++){
            let irow = natives[i]
            idxl.push(irow.idx)
            ctrls.push(irow.result)
        }


        let dlst = []
        for(let i=0; i<ctrls.length; i++){
            let irow = ctrls[i]

            let pit = { min:1000, max:-1000, dist:0 }
            for(let j=0; j<irow.length; j++){
                let jrow = irow[j];

                if (!jrow.pron || jrow.pron == "(NULL)") continue;

                let len = { min:1000, max:-1000 };
                let per = { min:1000, max:-1000 };

                if( i > 0 ){
                    len = lens[j]
                    per = pers[j]
                }

                if( i == 0 && j == 0 ){
                    len.max = jrow.len
                    per.max = jrow.per
                }


                if( !len ) continue;

                // min/max value
                if( jrow.len < len.min ) len.min = jrow.len
                if( len.max < jrow.len ) len.max = jrow.len

                // match rate(not used)
                if( jrow.per < per.min ) per.min = jrow.per
                if( per.max < jrow.per ) per.max = jrow.per

                lens[j] = len
                pers[j] = per

                // average
                if( !avgs[j] ) avgs[j] = []
                avgs[j].push(jrow.len)


                // pitch min/max
                if( pit.min > jrow.pitch && jrow.pitch > 0 ){
                    pit.min = jrow.pitch
                }
                if( pit.max < jrow.pitch ){
                    pit.max = jrow.pitch
                }


                // intensity min/max
            }


            // pitch min/max/distance
            pit.dist = pit.max - pit.min>0?pit.max - pit.min:0
            pit.idx = idxl[i]
            dlst.push(pit)
            if( pmin.dist > pit.dist ){
                pmin.dist = pit.dist
                pmin.idx = idxl[i]
            }
            if( pmax.dist < pit.dist ){
                pmax.dist = pit.dist
                pmax.idx = idxl[i]
            }
            
            for(let k=0; k<natives.length; k++){
                let krow = natives[k];
                if( krow.idx == idxl[i] ){
                    natives[k]['pitch_answer'] = { dist:pit }
                    break;
                }
            }
        }


        // Accumulation of Token Accuracy
        for(let i=0; i<avgs.length; i++){
            avgs[i] = (avgs[i].reduce((a, b) => a + b, 0)/avgs[i].length);
        }


        // pitch distance guide
        let dist = []
        for(let i=0; i<dlst.length; i++){
            let irow = dlst[i]
            if( dlst.length > 3 ){
                if( irow["idx"] != pmin.idx && irow["idx"] != pmax.idx ){
                    dist.push(irow["dist"])
                }
            } else {
                dist.push(irow["dist"])
            }
            if( pitch.min > irow.dist ) pitch.min = irow.dist
            if( pitch.max < irow.dist ) pitch.max = irow.dist
        }

        let sum = 0.0
        for (let i=0; i<dist.length; i++)
            sum += dist[i]

        pitch.dist = sum / dist.length


        pitch.dlst = dlst

        return {
            list : ctrls,
            idxl : idxl,
            lens : lens,
            pers : pers,
            avgs : avgs,
            pitch : pitch
        }
    }


    median = (data=[]) => {
        data = data.sort((a, b) => a - b)
        let n = Math.floor(data.length / 2)
        return (data[n] + data[data.length - 1 - n]) / 2
    }


    average = (array=[]) => {
        let sum = 0.0;
        for (var i = 0; i < array.length; i++)
            sum += array[i];
        return sum / array.length;
    }


    // get grade from score. [best;good;average;fair;poor]
    getGrade = (score) => {
        let grade = 'poor';
        if( 4 < score ){
            grade = 'best'
        } else if ( 3 < score && score <= 4 ){
            grade = 'good'
        } else if ( 2 < score && score <= 3 ){
            grade = 'average'
        } else if ( 1 < score && score <= 2 ){
            grade = 'fair'
        } else {
            grade = 'poor'
        }
        return grade;
    }


    run = (target, natives) => {
        // 발음 평가 함수

        // 발음 길이 갯수
        if( natives.lens.length == 0 ) return target

        target.phonemes = this.makeTokenScript(target.script, target.phonemes)

        // 단어 수
        target.words_cnt = target.script.split(' ').length

        // length evaluate
        let len_tot = 0
        for(let i=0; i<target.result.length; i++){
            let irow = target.result[i];

            let len = natives.lens[i]
            // let per = pers[i]

            if( natives.lens.length - 1 < i ) continue;
            irow.min = len.min
            irow.max = len.max

            let best    = parseFloat(this.opts.base.best)
            let good    = parseFloat(this.opts.base.good)
            let average = parseFloat(this.opts.base.average)
            let fair    = parseFloat(this.opts.base.fair)

            if( len.min * ((100-best)/100) <= irow.len && irow.len <= len.max * ((100+best)/100) ){
                // best score
                irow.score = 5
            } else if( len.min * ((100-good)/100) <= irow.len && irow.len <= len.max * ((100+good)/100) ){
                // good score
                irow.score = 4
            } else if ( len.min * ((100-average)/100) <= irow.len && irow.len <= len.max * ((100+average)/100) ){
                // average score
                irow.score = 3
            } else if ( len.min * ((100-fair)/100) <= irow.len && irow.len <= len.max * ((100+fair)/100) ){
                // fair score
                irow.score = 2
            } else {
                // poor score
                irow.score = 1
            }

            irow.avg = natives.avgs[i]
            irow.erate = Math.round((Math.abs(natives.avgs[i]-irow.len)/natives.avgs[i])*100)                    // error rate calculate
            irow.rate = 100 - irow.erate

            len_tot += irow.len

            target.result[i] = irow
        }
        target['len_tot'] = len_tot*10                // 10분의 1초이므로 초단위로 변경


        // pitch dir evaluate
        target = this.doEvaluatePitch(target, natives.list, natives.idxl)


        let avg_score = 0
        let avg_grade = ''

        let avg_score_pd = 0
        let avg_grade_pd = ''

        if( target.result.length <= 0 ) {
            target['avg_grade'] = avg_grade
            return target
        }
        

        let index = 0
        for(let i=0; i<target.phonemes.length; i++){
            let irow = target.phonemes[i]

            let total = 0
            let grade = ''
            let analysis = []

            if( target.result.length <= 0 ) continue;

            for(let j=0; j<irow.jsgf.length; j++){
                if( index > target.result.length ) continue;

                let jrow = target.result[index]

                if( !target.result[index] ) continue;

                // 분석결과 저장
                analysis.push({ pron:jrow.pron, min:jrow.min, max:jrow.max, rate:jrow.rate, erate:jrow.erate, len:jrow.len, avg:jrow.avg })
                // 스코어 합계 계산
                total += jrow.score

                index++
            }

            irow.analysis = analysis

            irow.total = total

            // 스코어 등급 계산
            // let score = Math.round(total/irow.jsgf.length)
            let score = (total/irow.jsgf.length)
            grade = this.getGrade(score)
            irow.score = score
            irow.grade = grade

            avg_score += score




            // pitch guide cut
            let score_pd = score
            let pitch_guide = 0
            if( natives.pitch.dist > 0 ){
                pitch_guide = (target.pitch_dist.val)/(natives.pitch.dist)*100.0
            }
            if( pitch_guide < (100-this.opts.base.pitch_guide.good) ){
                // pitch guide가 최대 average
                if( score_pd >= 3 ){
                    // score_pd가 good 이상이면 
                    score_pd = 2.99
                }
            } else if ( (100-this.opts.base.pitch_guide.good) <= pitch_guide && pitch_guide < (100-this.opts.base.pitch_guide.best) ){
                // pitch guide가 최대 good
                if( score_pd >= 4 ){
                    score_pd = 3.99
                }
            }
            irow.score_pd = score_pd
            irow.grade_pd = this.getGrade(score_pd)
            avg_score_pd += score_pd

            target.phonemes[i] = irow
        }


        // pron token score
        target['avg_score'] = (avg_score/target.phonemes.length)
        avg_grade = this.getGrade((target['avg_score']))
        target['avg_grade'] = avg_grade


        // pitch direction score
        target['avg_score_p'] = target['pitch_dir']['rate']/20
        target['avg_grade_p'] = this.getGrade((target['avg_score_p']))


        // pitch distance guide cut score
        target['avg_score_pd'] = (avg_score_pd/target.phonemes.length)
        avg_grade_pd = this.getGrade((target['avg_score_pd']))
        target['avg_grade_pd'] = avg_grade_pd
        target['pitch_dist']["score"] = this.getPitchDistScore(target['pitch_dist']["val"])
        target['pitch_dist']["grade"] = this.getGrade(target['pitch_dist']["score"])


        // pronunce length & pitch direction extension score
        let pitch_weight = this.opts.base.pitch_weight/100
        target['avg_score_a'] = ((target['avg_score']*20)*(1-pitch_weight) + target['pitch_dir']['rate']*pitch_weight)/20
        target['avg_grade_a'] = this.getGrade((target['avg_score_a']))

        // pronunce length + pitch direction + pitch distance
        let pitch_weight_dist = this.opts.base.pitch_weight_dist/100
        let plen = ((target['avg_score']*20)*(1-(pitch_weight+pitch_weight_dist)))
        let pdir = ((target['avg_score_p']*20)*pitch_weight)
        let pdis = ((target['pitch_dist']["score"]*20)*pitch_weight_dist)
        let pscore = ((plen + pdir + pdis)/20)
        let pgrade = this.getGrade((pscore))
        target['pitch_dist']['t_score'] = pscore
        target['pitch_dist']['t_grade'] = pgrade
        // console.log(target.isnative
        //     , 'Len :: ' + plen.toFixed(1)
        //     , ', Dir :: ' + pdir.toFixed(1)
        //     , ', Dis :: ' + pdis.toFixed(1)
        //     , ', Tot :: ' + pscore.toFixed(1), pgrade
        // )

        return target
    }


    getPitchDistScore = (dist) => {
        let rate = parseInt(dist)
        let base = this._opts.base.pitch_guide
        let score = 0
        if( 100-base.best <= rate ){
            score = 5
        } else if ( 100-base.good <= rate && rate < 100-base.best ){
            score = 4
        } else if ( 100-base.average <= rate && rate < 100-base.good ){
            score = 3
        } else if ( 100-base.fair <= rate && rate < 100-base.average ){
            score = 2
        } else {
            score = 1
        }

        return score
    }


    makeTokenScript = (s, t) => {
        let pos = 0
        let cs = s

        for(let i=0; i<t.length; i++){
            let irow = t[i]

            let token = irow['token'].toLowerCase()
            let pron = irow['phonemes'].join('')

            pos = cs.toLowerCase().indexOf(token)

            let ct = ''
            let pt = ''
            if( pos >= 0 ){
                ct = cs.substr(0, pos + token.length)
                pt = cs.substr(0, pos) + pron
            } else {
                console.log(cs, token)
            }

            if( i == t.length - 1 ){
                ct = cs.substr(0)
                pt += cs.substr(pos + token.length)
            }

            irow['token_txt'] = ct
            irow['pron_txt'] = pt
            cs = cs.substr(ct.length)

            t[i] = irow

        }

        return t
    }

    
    doEvaluatePitch = (target, native_rules_list, native_rules_indices) => {
        // pitch direction evaluate guide
        target['pitch_answer'] = {
            list : [],   // pitch direction evaluate native match 
            cnt  : 0,    // pitch direction match cnt average
            rate : 0,    // pitch direction match rate average
            best : 0,    // best match native index
        }

        target['pitch_dist'] = {    // pitch distance guide match
            list   : [], 
            min    : 1000,      // pitch min height
            max    : -1000,     // pitch max height
            avg    : 0,         // pitch height average
            mid    : 0,         // pitch height middle point
            val    : 0,         // pitch min-max distance
            normal : '',        // distance normalized grade
        }

        if( target.result.length > 0 ){
            let dir = {
                list : [],
                cnt  : 0,
                rate : 0,
                best : 0,
            }

            for(let i=0; i<native_rules_list.length; i++){
                let irow = native_rules_list[i]

                let pitch_ans = 0
                for(let j=0; j<irow.length; j++){
                    let srow = irow[j]
                    if( !target.result[j] ) continue;

                    let trow = target.result[j]

                    if(srow['pitch_dir'] == trow['pitch_dir']){
                        pitch_ans++
                    }
                }

                
                if( dir["cnt"] < pitch_ans ) {
                    dir.cnt  = pitch_ans
                    dir.rate = pitch_ans / target.result.length * 100
                    dir.best = native_rules_indices[i]
                }

                dir.list.push({
                    idx : native_rules_indices[i],
                    cnt : pitch_ans, 
                    rate : pitch_ans / target.result.length * 100
                })
            }
            // dir.cnt = dir.cnt / native_rules_list.length
            // dir.rate = dir.rate / native_rules_list.length
            // dir.best = this.bestMatch(dir.list)

            target['pitch_dir'] = {
                list : dir.list,
                cnt  : dir.cnt,
                rate : dir.rate,
                best : dir.best,
            }
            // console.log(target)



            // pitch distance evaluate guide
            let dist = { 
                min: 1000,
                max:-1000,
                avg:0,
                mid:0,
                val:0,
            }

            let dlst = []
            let sum = 0
            for(let i=0; i<target.result.length; i++){
                let irow = target.result[i]
                dlst.push(irow.pitch)
                sum += irow.pitch

                if(dist.min > irow.pitch && irow.pitch > 0 ){
                    dist.min = irow.pitch
                }

                if(dist.max < irow.pitch){
                    dist.max = irow.pitch
                }
            }

            dist.avg = sum/target.result.length
            dist.val = dist.max - dist.min > 0?dist.max - dist.min:0
            dist.mid = this.median(dlst)

            target['pitch_dist'] = dist
        }
        
        return target
    }


    // best match index
    bestMatch = (obj) => {
        const sortedEntriesByVal = Object.entries(obj).sort(([, v1], [, v2]) => v1['rate'] - v2['rate']);

        return sortedEntriesByVal[sortedEntriesByVal.length - 1][1]['idx'];
    }

}

export function useEvaluator() { return new Prontest() }

export { Prontest }